module.exports = __webpack_public_path__ + "static/img/zhuanjia.cb10b27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhuanjia.png
// module id = pM7u
// module chunks = 26